import { Button, Stack } from '@mui/material';
import {
  IMPORT_MORE,
  useDtoolsImport,
} from 'src/components/ImportDtoolsProjectModal/dtools-import-context';
import { ImportResults } from 'src/components/ImportDtoolsProjectModal/import-results';
import { ModalStep, useModalStep } from 'src/components/ModalContainer';

/** Step 3: per-project results of the import; it opens while the job still runs and fills in. */
export const ImportJobDialog = () => {
  const { popStep } = useModalStep();
  const { importOutcome, close } = useDtoolsImport();
  const { isFinished, projectIds, records, errors, loading, hasMoreResults, loadMoreResults } =
    importOutcome;

  // Every project failing is still a failed import, even though the job itself finished.
  const importFailed = isFinished && projectIds.length > 0 && records.length === 0;
  const title = (() => {
    if (!isFinished) {
      return 'Importing';
    }
    return importFailed ? 'Import failed' : 'Import complete';
  })();

  return (
    <ModalStep
      title={title}
      actions={[
        {
          label: 'Import more',
          kind: 'secondary',
          onClick: () => popStep(IMPORT_MORE),
          disabled: !isFinished,
          testId: 'import-dtools-projects-results-import-more',
        },
        {
          label: isFinished ? 'Done' : 'Close',
          kind: 'primary',
          onClick: close,
          testId: 'import-dtools-projects-results-done',
        },
      ]}
    >
      <Stack gap={2} data-testid="import-dtools-projects-results">
        <ImportResults
          records={records}
          loading={loading || !isFinished}
          projectIds={projectIds}
          errors={errors}
        />
        {hasMoreResults ? (
          <Button onClick={loadMoreResults} sx={{ alignSelf: 'flex-start' }}>
            Show more results
          </Button>
        ) : null}
      </Stack>
    </ModalStep>
  );
};
